<template>
    <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" href="#" :id="`navbar${title}Dropdown`" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{title}}
        </a>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarViewsDropdown">
            <div v-for="item in menuItems" :key="item.id" >
                <div v-if="item.visible && item.url && item.url.includes('http')">
                    <a :href="item.url" :key="item.id" class="dropdown-item" target="blank">
                        {{item.text}}
                        <i class="ml-1 fa fa-external-link" />
                    </a>
                </div>
                <div v-if="item.visible && item.url && !item.url.includes('http')">
                    <router-link :to="item.url" :key="item.id" class="dropdown-item">{{item.text}}</router-link>
                </div>
                <div v-if="item.visible && item.click">
                    <a href="#" @click.prevent="item.click" class="dropdown-item">{{item.text}}</a>
                </div>
            </div>
        </div>
    </li>
</template>

<script>

export default {
    props: ["menuItems", "title"],
    data() {
        return { }
    },
    computed: {
    }
}
</script>



// WEBPACK FOOTER //
// src/framework/TopBarMenu.vue